/**
 *
 * Asynchronously loads the component for GoogleAuth and NewGoogleAuth
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const GoogleAuth = lazyLoad(
    () => import('./index'),
    module => module.default,
);

export const NewGoogleAuth = lazyLoad(
    () => import('./NewGoogleAuth'),
    module => module.default,
);
